import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsEmbeddedWidgetsRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-embedded-widgets',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/embed',
	exact: true,
};
